const IDRtoppayOptions = [
    {
        label: "Anglomas International Bank",
        value: "531",
    },
    {
        label: "ARTAJASA PEMBAYARAN ELEKTRONIK",
        value: "987",
    },
    {
        label: "Allo Bank/Bank Harda Internasional",
        value: "567",
    },
    {
        label: "Bank Aceh Syariah",
        value: "116",
    },
    {
        label: "Bank Agris UUS",
        value: "1160",
    },
    {
        label: "BPD ISTIMEWA ACEH SYARIAH",
        value: "1161",
    },
    {
        label: "Bank IBK Indonesia",
        value: "945",
    },
    {
        label: "BANK AMAR INDONESIA",
        value: "1162",
    },
    {
        label: "Bank Agroniaga",
        value: "494",
    },
    {
        label: "Bank Andara",
        value: "466",
    },
    {
        label: "BANK ANTAR DAERAH",
        value: "1163",
    },
    {
        label: "Bank ANZ Indonesia",
        value: "061",
    },
    {
        label: "Bank ANZ PANIN",
        value: "0610",
    },
    {
        label: "Bank Arta Niaga Kencana",
        value: "020",
    },
    {
        label: "Bank Artha Graha Internasional",
        value: "037",
    },
    {
        label: "Bank ARTOS/ Bank Jago",
        value: "542",
    },
    {
        label: "BPD Bali",
        value: "129",
    },
    {
        label: "Bank Bisnis Internasional",
        value: "459",
    },
    {
        label: "Bangkok Bank",
        value: "040",
    },
    {
        label: "BPD Banten",
        value: "558",
    },
    {
        label: "BANK BARCLAYS INDONESIA",
        value: "525",
    },
    {
        label: "Bank Central Asia",
        value: "014",
    },
    {
        label: "Bank Central Asia (BCA) Syariah",
        value: "536",
    },
    {
        label: "Bank Bengkulu",
        value: "133",
    },
    {
        label: "Bank Jawa Barat(BJB)",
        value: "110",
    },
    {
        label: "Bank BJB Syariah",
        value: "425",
    },
    {
        label: "Bank Negara Indonesia(BNI)",
        value: "009",
    },
    {
        label: "Bank BNI Syariah",
        value: "427",
    },
    {
        label: "BANK OF CHINA LIMITED",
        value: "069",
    },
    {
        label: "Bank Rakyat Indonesia(BRI)",
        value: "002",
    },
    {
        label: "Bank BRI Syariah",
        value: "422",
    },
    {
        label: "Bank BNP Paribas",
        value: "1450",
    },
    {
        label: "BANK OF AMERICA NA",
        value: "033",
    },
    {
        label: "BPR KS",
        value: "688",
    },
    {
        label: "Bank Syariah Indonesia(BSI)",
        value: "4510",
    },
    {
        label: "Bank Tabungan Negara (BTN)",
        value: "200",
    },
    {
        label: "Bank Tabungan Negara (BTN) UUS",
        value: "2000",
    },
    {
        label: "Bank BTPN",
        value: "213",
    },
    {
        label: "BTPN Syariah",
        value: "5470",
    },
    {
        label: "Bank BTPN Syariah",
        value: "547",
    },
    {
        label: "Bank Bukopin Syariah",
        value: "521",
    },
    {
        label: "Bank Bumi Arta",
        value: "076",
    },
    {
        label: "BANK BUMIPUTERA",
        value: "4850",
    },
    {
        label: "Bank Capital Indonesia",
        value: "054",
    },
    {
        label: "BANK CENTRATAMA",
        value: "5590",
    },
    {
        label: "BANK CHINA CONSTRUCTION",
        value: "9490",
    },
    {
        label: "Bank CIMB Niaga",
        value: "022",
    },
    {
        label: "Bank CIMB Niaga UUS",
        value: "0220",
    },
    {
        label: "Bank CIMB Niaga REKENING PONSEL",
        value: "0221",
    },
    {
        label: "Bank Commonwealth",
        value: "950",
    },
    {
        label: "BPD DIY",
        value: "112",
    },
    {
        label: "BANK PEMBANGUNAN DAERAH DIY UNIT USAHA SYARIAH",
        value: "1121",
    },
    {
        label: "Bank Danamon",
        value: "011",
    },
    {
        label: "Bank Danamon UUS",
        value: "0110",
    },
    {
        label: "Bank DBS Indonesia",
        value: "046",
    },
    {
        label: "Bank Dinar Indonesia",
        value: "526",
    },
    {
        label: "BANK DIPO INTERNATIONAL",
        value: "5230",
    },
    {
        label: "Bank DKI",
        value: "111",
    },
    {
        label: "Bank DKI UUS",
        value: "778",
    },
    {
        label: "Bank EKA",
        value: "699",
    },
    {
        label: "BANK EKONOMI RAHARJA",
        value: "087",
    },
    {
        label: "Bank Fama International",
        value: "562",
    },
    {
        label: "Bank Ganesha",
        value: "161",
    },
    {
        label: "Bank Himpunan Saudara 1906",
        value: "2120",
    },
    {
        label: "Bank ICBC Indonesia",
        value: "164",
    },
    {
        label: "Bank Ina Perdana",
        value: "513",
    },
    {
        label: "Bank Index Selindo",
        value: "555",
    },
    {
        label: "Bank of India Indonesia",
        value: "146",
    },
    {
        label: "BANK JAGO TBK",
        value: "5421",
    },
    {
        label: "Bank Jambi",
        value: "115",
    },
    {
        label: "Bank Jasa Jakarta",
        value: "472",
    },
    {
        label: "Bank Jateng",
        value: "113",
    },
    {
        label: "BPD JAWA TENGAH UNIT USAHA SYARIAH",
        value: "1130",
    },
    {
        label: "Bank Jatim",
        value: "114",
    },
    {
        label: "BPD Jawa Timur",
        value: "1140",
    },
    {
        label: "Bank Jatim UUS",
        value: "1141",
    },
    {
        label: "Bank JTrust Indonesia",
        value: "095",
    },
    {
        label: "BPD Kalimantan Barat/Kalbar",
        value: "123",
    },
    {
        label: "BPD Kalimantan Barat UUS",
        value: "1230",
    },
    {
        label: "BPD Kalimantan Selatan/Kalsel",
        value: "122",
    },
    {
        label: "BPD Kalimantan Selatan UUS",
        value: "1220",
    },
    {
        label: "BPD Kalimantan Tengah (Kalteng)",
        value: "125",
    },
    {
        label: "BPD Kalimantan Timur",
        value: "124",
    },
    {
        label: "BPD Kalimantan Timur UUS",
        value: "1240",
    },
    {
        label: "BPD Lampung",
        value: "121",
    },
    {
        label: "Bank Maluku",
        value: "131",
    },
    {
        label: "Bank Mandiri",
        value: "008",
    },
    {
        label: "Bank Syariah Mandiri",
        value: "451",
    },
    {
        label: "Bank Mandiri Taspen Pos",
        value: "5640",
    },
    {
        label: "Bank MANTAP",
        value: "564",
    },
    {
        label: "Bank Multi Arta Sentosa(MAS)",
        value: "548",
    },
    {
        label: "Bank Maspion Indonesia",
        value: "157",
    },
    {
        label: "Bank Mayapada",
        value: "097",
    },
    {
        label: "Bank Maybank",
        value: "016",
    },
    {
        label: "Bank Maybank Syariah Indonesia",
        value: "947",
    },
    {
        label: "Bank Maybank Syariah Indonesia UUS",
        value: "0160",
    },
    {
        label: "Bank Mayora Indonesia",
        value: "553",
    },
    {
        label: "Bank Mega",
        value: "426",
    },
    {
        label: "Bank Mega Syariah",
        value: "506",
    },
    {
        label: "Bank Mestika Dharma",
        value: "151",
    },
    {
        label: "BANK METRO EXPRESS",
        value: "1520",
    },
    {
        label: "Bank Muamalat Indonesia",
        value: "147",
    },
    {
        label: "Bank Mitra Niaga",
        value: "491",
    },
    {
        label: "Bank Mizuho Indonesia",
        value: "048",
    },
    {
        label: "Bank MUTIARA",
        value: "10010",
    },
    {
        label: "Bank MULTICOR",
        value: "10006",
    },
    {
        label: "Bank National Nobu",
        value: "503",
    },
    {
        label: "BANK NIAGA TBK. SYARIAH",
        value: "583",
    },
    {
        label: "BPD Nusa Tenggara Barat(NTB)",
        value: "128",
    },
    {
        label: "BPD Nusa Tenggara Barat (NTB) UUS",
        value: "1280",
    },
    {
        label: "BPD Nusa Tenggara Timur(NTT)",
        value: "130",
    },
    {
        label: "Bank Nusantara Parahyangan",
        value: "145",
    },
    {
        label: "Bank OCBC NISP",
        value: "028",
    },
    {
        label: "Bank OCBC NISP UUS",
        value: "0280",
    },
    {
        label: "Bank Panin",
        value: "019",
    },
    {
        label: "Bank Papua",
        value: "132",
    },
    {
        label: "Bank Permata",
        value: "013",
    },
    {
        label: "Bank Permata UUS",
        value: "0130",
    },
    {
        label: "Bank Prima Master",
        value: "520",
    },
    {
        label: "BANK PUNDI INDONESIA",
        value: "584",
    },
    {
        label: "Bank Oke Indonesia",
        value: "5260",
    },
    {
        label: "Bank Resona Perdania",
        value: "047",
    },
    {
        label: "BPD Riau Dan Kepri",
        value: "119",
    },
    {
        label: "BPD Riau Dan Kepri UUS",
        value: "1190",
    },
    {
        label: "Blu/BCA Digital",
        value: "5010",
    },
    {
        label: "BANK PURBA DANARTA",
        value: "5471",
    },
    {
        label: "Bank Sahabat Sampoerna",
        value: "523",
    },
    {
        label: "Bank SBI Indonesia",
        value: "498",
    },
    {
        label: "Bank Shinhan Indonesia",
        value: "152",
    },
    {
        label: "Bank Sinarmas",
        value: "153",
    },
    {
        label: "Bank Sinarmas UUS",
        value: "1530",
    },
    {
        label: "Bank Sulteng",
        value: "134",
    },
    {
        label: "Bank Sultra",
        value: "135",
    },
    {
        label: "Bank Sulselbar",
        value: "126",
    },
    {
        label: "Bank Sulselbar UUS",
        value: "1260",
    },
    {
        label: "BPD Sulawesi Utara(SulutGo)",
        value: "127",
    },
    {
        label: "BPD Sumatera Barat",
        value: "118",
    },
    {
        label: "BPD Sumatera Barat UUS",
        value: "1180",
    },
    {
        label: "BANK NAGARI",
        value: "1181",
    },
    {
        label: "BPD Sumsel Babel",
        value: "120",
    },
    {
        label: "Bank Sumsel Babel",
        value: "1200",
    },
    {
        label: "Bank Sumsel Dan Babel UUS",
        value: "1201",
    },
    {
        label: "Bank Sumut",
        value: "117",
    },
    {
        label: "Bank Sumut UUS",
        value: "1170",
    },
    {
        label: "Bank Sumitomo Mitsui Indonesia",
        value: "045",
    },
    {
        label: "Bank of Tokyo",
        value: "042",
    },
    {
        label: "Bank Victoria International",
        value: "566",
    },
    {
        label: "Bank Victoria Syariah",
        value: "405",
    },
    {
        label: "Bank Woori Saudara",
        value: "212",
    },
    {
        label: "BPD_Daerah_Istimewa_Yogyakarta_(DIY)",
        value: "1120",
    },
    {
        label: "CTBC Indonesia",
        value: "949",
    },
    {
        label: "Centratama Nasional Bank(CNB)",
        value: "559",
    },
    {
        label: "Citibank",
        value: "031",
    },
    {
        label: "CCB Indonesia",
        value: "088",
    },
    {
        label: "Deutsche Bank",
        value: "067",
    },
    {
        label: "DANA",
        value: "10002",
    },
    {
        label: "GOPAY",
        value: "10003",
    },
    {
        label: "HSBC",
        value: "041",
    },
    {
        label: "JPMORGAN CHASE BANK",
        value: "032",
    },
    {
        label: "LINE Bank/KEB Hana",
        value: "484",
    },
    {
        label: "LINKAJA",
        value: "10009",
    },
    {
        label: "Motion/Bank MNC Internasional",
        value: "485",
    },
    {
        label: "Neo Commerce/Bank Yudha Bhakti",
        value: "490",
    },
    {
        label: "OVO",
        value: "10001",
    },
    {
        label: "Panin Dubai Syariah",
        value: "517",
    },
    {
        label: "QNB KESAWAN",
        value: "167",
    },
    {
        label: "QNB Indonesia",
        value: "1670",
    },
    {
        label: "Rabobank International Indonesia",
        value: "089",
    },
    {
        label: "Royal Bank of Scotland (RBS)",
        value: "501",
    },
    {
        label: "Seabank/Bank Kesejahteraan Ekonomi(BKE)",
        value: "535",
    },
    {
        label: "Standard Chartered Bank",
        value: "050",
    },
    {
        label: "SHOPEEPAY",
        value: "10008",
    },
    {
        label: "TMRW/Bank UOB Indonesia",
        value: "023",
    },
    {
        label: "Wokee/Bukopin",
        value: "441",
    },
];

export default IDRtoppayOptions;
